import React, { Component } from 'react'
import { connect } from "react-redux"
import { AxiosResponse } from 'axios'

import {
    css,
    GridCell,
    Grid,
    Theme,
    Icon,
} from "@bdfx/mergado-ui-kit"

import { AlternativeTemplate, Template } from 'app/types/model-types'
import { selectFormValues } from 'app/reducers/form'
import { InpaintingGroupType } from 'products/types'
import { ReduxList } from 'app/types/app-types'
import { WatermarksRenderSvgObjects } from 'products/components/render-objects-helper'
import { isJson } from 'app/helpers/other'

import {
    updateInputValue as change,
} from "app/reducers/form"
import { URL } from 'app/config/api-config'
import { deleteInpaintingGroup, getInpaintingGroups } from 'app/helpers/api'
import { setInpaintingGroupsToStore } from 'watermark-groups/reducers'
import { getFormName } from '../../shape-edit/forms/helpers';
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

export interface Props {
    close?: Function
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    inpaintingGroups: ReduxList<InpaintingGroupType[]>
    change: typeof change,
    setInpaintingGroupsToStore: typeof setInpaintingGroupsToStore
}

class InpaintingGroupSelect extends Component<Props> {
    constructor(props) {
        super(props)
    }

    deleteGroup = (inpaintingGroupId: number) => {
        deleteInpaintingGroup(inpaintingGroupId)
            .then((response: AxiosResponse<any>) => {
                this.updateInpaintingGroups()

        })
    }

    updateInpaintingGroups = () => {
            getInpaintingGroups()
            .then((response: AxiosResponse<InpaintingGroupType[]>) => {
                    this.props.setInpaintingGroupsToStore(response.data)
                })
                .catch(e => {
                    console.error('cannot get inpainting groups', e)
                })
        }

    render() {
        const { inpaintingGroups, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        return (
            <React.Fragment>
                {inpaintingGroups && inpaintingGroups.data && inpaintingGroups.data.length > 0 &&
                    <StyledGrid>
                        {inpaintingGroups.data.map((inpaintingGroup: InpaintingGroupType) => {
                            const isActive = `${form.inpainting_group_id}` === `${inpaintingGroup.id}`
                            return <GridCell key={`inpainting_group_${inpaintingGroup.id}`}>
                                <div style={{ fontSize: 'small' }}>
                                    {inpaintingGroup.width}x{inpaintingGroup.height}&nbsp;&nbsp;
                                    {inpaintingGroup.pos_relative_to ?
                                        <img src={`${URL.publicPath}img/icons/position-${inpaintingGroup.pos_relative_to}.svg`} width={15} height={15} /> :
                                        <Icon type="expand" size={20} />
                                    }

                                    <span className='clickable' onClick={() => this.deleteGroup(inpaintingGroup.id)}>
                                        <Icon type={'trash-o'} color={Theme.red} size={20} />
                                    </span>
                                </div>
                                <div
                                    title={`${inpaintingGroup.pos_relative_to ? inpaintingGroup.pos_relative_to : 'abs'} ${inpaintingGroup.scale_objects ? ' resize' : ' keep size'}`}
                                    className='clickable'
                                    onClick={() => {
                                        this.props.change(formName, 'inpainting_group_id', inpaintingGroup.id)
                                        if (typeof this.props.close === 'function') {
                                            this.props.close()
                                        }
                                    }}>

                                    <svg
                                        version="1.1"
                                        viewBox={`0 0 ${inpaintingGroup.width} ${inpaintingGroup.height}`}
                                        width={inpaintingGroup.width}
                                        height={inpaintingGroup.height}
                                        preserveAspectRatio={'xMidYMid meet'}
                                        className={`preview-svg ${isActive ? 'active' : ''}`}>

                                        <pattern id={`pattern-checkers-${inpaintingGroup.id}`} x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
                                            <rect className="checker" x="0" width="100" height="100" y="0" fill="#ccc" />
                                            <rect className="checker" x="100" width="100" height="100" y="100" fill="#ccc"/>
                                        </pattern>

                                        <rect
                                            x="0"
                                            y="0"
                                            width="100%"
                                            height="100%"
                                            fill={`url(#pattern-checkers-${inpaintingGroup.id})`}
                                            opacity={.5}
                                            stroke={isActive ? Theme.blue : 'tranparent'}
                                            strokeWidth={4}
                                        />

                                        {inpaintingGroup.user_set_objects && isJson(inpaintingGroup.user_set_objects) &&
                                            <WatermarksRenderSvgObjects
                                                objects={JSON.parse(inpaintingGroup.user_set_objects)}
                                                color={Theme.blue}
                                                opacity={1}
                                            />
                                        }
                                    </svg>
                                </div>
                            </GridCell>
                        })}
                    </StyledGrid>
                }
            </React.Fragment>
        )
    }
}

const StyledGrid = css(Grid)({
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' .preview-svg': {
        maxWidth: '70px',
        maxHeight: '70px',
        border: '2px solid transparent',
    },
    ' .active': {
        border: `2px solid ${Theme.blue}`,
    },
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        inpaintingGroups: state.inpaintingGroups,
    }
}

export default connect(mapStateToProps, {
    change,
    setInpaintingGroupsToStore,
})(InpaintingGroupSelect)